import React from "react";


const DownloadingOverlay = ({ message = "Đang tải xuống..." }) => {
    return (
        <div className="fixed inset-0 flex items-center justify-center bg-black/30 backdrop-blur-sm z-[100]">
            <div
                className="flex flex-col items-center space-y-5 p-8 bg-white/90 rounded-2xl shadow-lg animate-fadeIn">
                <div className="relative">
                    <div
                        className="w-20 h-20 rounded-full bg-gradient-to-br from-blue-500 to-purple-500 flex items-center justify-center shadow-lg">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="w-10 h-10 text-white animate-bounce"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                            strokeWidth={2}
                        >
                            <path strokeLinecap="round" strokeLinejoin="round"
                                  d="M4 16v2a2 2 0 002 2h12a2 2 0 002-2v-2M8 12l4 4 4-4m-4-8v12"/>
                        </svg>
                    </div>
                </div>

                <span className="text-gray-800 text-lg font-semibold animate-pulse">
                            Đang tải xuống dữ liệu...
                        </span>
            </div>
        </div>
    );
};

export default DownloadingOverlay;
